import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">电影分类</h2>
            <p className="text-xs md:text-sm text-foreground-400 mt-1">探索不同类型的精彩电影</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200 flex-shrink-0">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-400`}></i>
              </div>
              <div>
                <span className="text-sm md:text-base font-medium text-foreground-100 group-hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.count}部影片</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}